import { Snackbar } from "@sopheos/orbjs_snackbar";

/**
 * @type {AgendaSnackbar}
 */
let _instanceSnackbar = null;

/**
 * @extends Snackbar
 */
class AgendaSnackbar extends Snackbar {
  // Types
  TYPE_ERROR = 1;
  // Keys
  ERROR = 1;
  LOGOUT = 2;
  FAVORITE = 4;
  INFO = 8;
}

/**
 *
 * @returns {AgendaSnackbar}
 */
export function useSnackbar() {
  if (!_instanceSnackbar) {
    const snackbarStore = useSnackbarStore();

    _instanceSnackbar = new AgendaSnackbar((options) => {
      snackbarStore.open = options.open;
      snackbarStore.type = options.type;
      snackbarStore.message = options.message;
      snackbarStore.action = options.action;
      snackbarStore.close = options.close;
    });
  }
  return _instanceSnackbar;
}
